window.Vue = require('vue');

Vue.component(
    'card-masonry',
    require('./vue-components/card-masonry.vue').default
);

Vue.component(
    'full-ad',
    require('./vue-components/full-advertise.vue').default
);

Vue.component(
    'photo-carousel',
    require('./vue-components/photo-carousel.vue').default
);

Vue.component(
    'store-list',
    require('./vue-components/store-list.vue').default
);

Vue.component(
    'search-button',
    require('./vue-components/search-field.vue').default
);

Vue.component(
    'ads-builder',
    require('./vue-components/ads-builder.vue').default
);

Vue.component(
    'select-store-list',
    require('./vue-components/select-store-list.vue').default
);

Vue.component(
    'select-user-list',
    require('./vue-components/select-user-list.vue').default
);

Vue.component(
    'res-dialog',
    require('./vue-components/res-dialog-v3').default
);

Vue.component(
    'res-list-dialog',
    require('./vue-components/reservations').default
);

Vue.component(
    'res-store-list',
    require('./vue-components/res-store-list').default
);

Vue.component(
    'res-times-config-dialog',
    require('./vue-components/reservation-times-config-dialog').default
);

Vue.component(
    'res-new-reserve-dialog',
    require('./vue-components/res-new-reserve-dialog').default
);

Vue.component(
    'store-event-creator',
    require('./vue-components/store-event-creator').default
);

Vue.component(
    'store-event-updater',
    require('./vue-components/store-event-updater').default
);

window.vm = new Vue({

    el: '#app',
    methods: {
        //methods for store event update in store table index admin version.
        onClickEventEdit(event, object) {
            this.$refs.eventupdater.$data.event = object;
            $('#event-updater').show();
        }
    }
});

window.headerVM = new Vue({
    el: '#search-anchor'
});

window.outerVM = new Vue({
    el: '#outer-components'
});